import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as fromRoot from '@app/reducers';
import { fadeInOutAnimation } from '@app/shared/animations/fadeinout-animations';
import { ThemeSimplified } from '@app/shared/helpers/theme';
import { Device } from '@app/shared/models/device';
import { TransferFile } from '@app/shared/models/transferFile';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ViewerActions } from '../../actions';
import * as fromViewer from '../../reducers/viewer.reducer';
import { GetTransferPreviewOutput } from '@smash-sdk/transfer/ejs/01-2024';
import { hostnameIsFromMainDomain } from '@app/shared/helpers/location';

@Component({
  selector: 'app-deck',
  templateUrl: './deck.component.html',
  styleUrls: ['./deck.component.scss'],
  animations: [
    fadeInOutAnimation
  ]
})
export class DeckComponent implements OnInit {

  @Input() preview: GetTransferPreviewOutput;
  @Input() files: TransferFile[];
  @Input() selectedFiles: TransferFile[];
  @Input() device: Device;
  @Output() videoPlaying: EventEmitter<any> = new EventEmitter<any>();

  filesLoading$: Observable<boolean>;
  theme$: Observable<ThemeSimplified>;
  countryCode$: Observable<string>;
  loadMoreClicked = false;
  isMainDomain: boolean;

  constructor(private store$: Store<fromRoot.State & fromViewer.State>) {
    this.isMainDomain = hostnameIsFromMainDomain(window.location.hostname);
  }

  ngOnInit() {
    this.filesLoading$ = this.store$.pipe(select(fromViewer.getFilesLoading));
    this.theme$ = this.store$.pipe(select(fromRoot.getTheme));
    this.countryCode$ = this.store$.pipe(select(fromRoot.getCountryCode));
  }

  getItems() {
    this.store$.dispatch(ViewerActions.LoadMoreFiles());
    this.loadMoreClicked = true;
  }

  identify(index, item): string {
    return item.id
  }

  onVideoPlaying(event) {
    this.videoPlaying.emit(event)
  }

}
